import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import type { StripeContextProps, StripeProviderProps } from './types';

export const StripeContext = React.createContext<StripeContextProps>({
  stripe: null,
});

export const StripeProvider: React.FC<
  React.PropsWithChildren<StripeProviderProps>
> = ({ children, language }) => {
  const [stripe, setStripe] = useState<stripe.Stripe | null>(null);

  const mounted = useRef(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  useEffect(() => {
    mounted.current = true;
    const stripeJs = document.createElement('script');

    stripeJs.src = 'https://js.stripe.com/v3/';
    stripeJs.async = true;

    stripeJs.onload = () => {
      // TODO: talk with the code owner to fix this code so we can enable this rule again
      if (mounted.current && process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY) {
        setStripe(
          // TODO: talk with the code owner to fix this code so we can enable this rule again
          window.Stripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY, {
            locale: language,
          }),
        );
      }
    };

    document.body.appendChild(stripeJs);

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <StripeContext.Provider value={{ stripe }}>
      {children}
    </StripeContext.Provider>
  );
};
